export default "__VITE_ASSET__RjBQ64jj__"